// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"124":"1ad34de6fa65ec9dd486","447":"ea9b41299f8300e9d0c9","872":"93ce13a4a20570391d1c"}[chunkId] + ".js";
};